import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import {BrowserRouter as Router,Switch,Route} from "react-router-dom";
import Header from './Components/Pages/Shared/Header/Header';
import Home from './Components/Pages/Home/Home';
import About from './Components/Pages/About/About';
import Services from './Components/Pages/Services/Services';
import Portfolio from './Components/Pages/Portfolio/Portfolio';
import Contact from './Components/Pages/Contact/Contact';
import Footer from './Components/Pages/Shared/Footer/Footer';
import NotFound from './Components/Pages/NotFound/NotFound';
import SingleWorks from './Components/Pages/Portfolio/SingleWorks/SingleWorks';
import Blog from './Components/Pages/Blog/Blog';

function App() {
  // const element = <FontAwesomeIcon icon={faCoffee} />
  return (
    <div className="App">
      <>
      <Router>
          <Header></Header>
          <Switch>
            <Route exact path="/">
              <Home></Home>
            </Route>
            <Route exact path="/home">
              <Home></Home>
            </Route>
            <Route exact path="/about">
              <About></About>
            </Route>
            <Route exact path="/services">
              <Services></Services>
            </Route>
            <Route exact path="/portfolio">
              <Portfolio></Portfolio>
            </Route>
            <Route exact path="/blog">
              <Blog></Blog>
            </Route>
            <Route exact path="/singleworks/:id">
              <SingleWorks></SingleWorks>
            </Route>
            <Route exact path="/contact">
              <Contact></Contact>
            </Route>
            <Route exact path="*">
              <NotFound></NotFound>
            </Route>
          </Switch>
          <Footer></Footer>
        </Router>
  
      </>
    </div>
  );
}

export default App;
